import React from 'react';
import { TrevorComponent } from '@trevor/ui-components';
import { useDatasourceId } from '@/hooks';
import { useGetNearestPriceTiersQuery } from '@/features/credits/apiSlice';
// eslint-disable-next-line camelcase
import { TMP_formatNumber } from '@/features/credits/utils';
import AjaxSpinner from '@/components/AjaxSpinner';
import { Link } from 'react-router-dom';
import { DescriptionText } from './styled-components';
import { TiersTable } from './TiersTable';

export const NearestTiersWidget: TrevorComponent<{ selectedPlan: string }> = ({
  className,
  selectedPlan,
}) => {
  const datasourceId = useDatasourceId();
  const { data: tiers, isLoading } = useGetNearestPriceTiersQuery(datasourceId);

  if (isLoading) {
    return <AjaxSpinner small />;
  }

  const selectedTiers = tiers && tiers[selectedPlan];

  return (
    <div className={className}>
      {selectedTiers && (
        <div>
          <DescriptionText>
            Based on your current usage of{' '}
            <Link to="../credits">
              {TMP_formatNumber(selectedTiers[0].currentUsage)}
            </Link>{' '}
            credits used during your free trial period
          </DescriptionText>
          <TiersTable
            selectedPlan={selectedPlan}
            selectedTiers={selectedTiers}
          />
        </div>
      )}
    </div>
  );
};
